/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class UiSlideOverComponent extends Component {
  @service fullCalendar;
  @service router;

  @action
  afterLeave() {
    if (this.router.currentRouteName?.includes('appointments')) {
      this.fullCalendar.calendarApi?.updateSize();
    }

    this.args.afterLeave?.();
  }
}
